import {z} from 'zod';

// a manually maintained index (ROBOR / IRCC): `previous` only drives the trend
// arrow, `date` is the "valid from" date shown in the detail view
const ManualIndex = z.object({
	value: z.number().nullable().optional(),
	previous: z.number().nullable().optional(),
	date: z.string().optional(),
}).optional();

// recent-coverage tags per detail-view section (OR-matched on the current domain);
// an explicit empty array turns the list off for that section
const NewsSection = z.object({
	tags: z.array(z.string()).optional(),
}).optional();

export default z.object({
	title: z.string().optional(),
	url: z.string().url().optional(),
	openInNewTab: z.boolean().optional(),
	// pinned BNR codes in display order; the detail view always lists all of them
	currencies: z.array(z.string()).optional(),
	showFuel: z.boolean().optional(),
	rates: z.object({
		robor3m: ManualIndex,
		robor6m: ManualIndex,
		ircc: ManualIndex,
	}).optional(),
	news: z.object({
		currency: NewsSection,
		fuel: NewsSection,
		index: NewsSection,
	}).optional(),
});
